/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/button/button';
import * as import2 from 'ionic-angular/config/config';
const styles_Button:any[] = ([] as any[]);
export const RenderType_Button:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Button,
  data: {}
}
);
export function View_Button_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'button-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'button-effect'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(null as any),(null as any));
}
function View_Button_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'ion-button',
        ''
      ]
    ],(null as any),(null as any),(null as any),View_Button_0,RenderType_Button)),
    import0.ɵdid(1097728,(null as any),0,import1.Button,[
      [
        8,
        ''
      ]
      ,
      import2.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ButtonNgFactory:import0.ComponentFactory<import1.Button> = import0.ɵccf('[ion-button]',import1.Button,View_Button_Host_0,{
  color: 'color',
  mode: 'mode',
  large: 'large',
  small: 'small',
  default: 'default',
  outline: 'outline',
  clear: 'clear',
  solid: 'solid',
  round: 'round',
  block: 'block',
  full: 'full',
  strong: 'strong'
}
,{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvYnV0dG9uL2J1dHRvbi5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvaW9uaWMtYW5ndWxhci9jb21wb25lbnRzL2J1dHRvbi9idXR0b24uZC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvYnV0dG9uL2J1dHRvbi5kLnRzLkJ1dHRvbi5odG1sIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvbm9kZV9tb2R1bGVzL2lvbmljLWFuZ3VsYXIvY29tcG9uZW50cy9idXR0b24vYnV0dG9uLmQudHMuQnV0dG9uX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNwYW4gY2xhc3M9XCJidXR0b24taW5uZXJcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9zcGFuPjxkaXYgY2xhc3M9XCJidXR0b24tZWZmZWN0XCI+PC9kaXY+IiwiPGRpdiBpb24tYnV0dG9uPjwvZGl2PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBMkI7TUFBZ0M7UUFBQTtRQUFBO01BQUE7SUFBQTs7Ozs7O01DQTNEO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7Ozs7SUFBQTtLQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/button/button.ngfactory.ts